import React, { useState, useEffect } from "react";
import { Box, Button, getColor, Typography } from "fds";
import "./index.scss";
import useLoginStore from "../../redux/dispatcher/useLoginStore";
import utilsCommon from "../../shared/utils/common";
import { t } from "i18next";
import { getUserInfoFromLocalStorage } from "../../shared/utils/auth";
import { LoginDto } from "../../types/auth";
import { useNavigate } from "react-router-dom";

const MoveToWebUsingBySyncId = ({
  changeLoading,
}: {
  changeLoading: (status: boolean) => void;
}) => {
  const user = getUserInfoFromLocalStorage() as string | "";
  const loginDto: LoginDto = JSON.parse(user);
  const { getInformationFromSyncId } = useLoginStore();
  const urlParmas = new URLSearchParams(window.location.search);
  const navigate = useNavigate();

  const [currStep, changeStep] = useState("LOADING");

  useEffect(() => {
    const syncId = urlParmas.get("syncId");
    if (!syncId) return;
    getInformationFromSyncId(syncId).then((resp: any) => {
      if (resp?.payload?.uniqueId) {
        window.location.href = `${process.env.PUBLIC_URL}/action/byuid/${resp.payload?.uniqueId}`;
      } else {
        changeStep("DELETED");
      }
    });
  }, [urlParmas]);
  return currStep === "LOADING" ? (
    <Box></Box>
  ) : (
    <Box
      width={"100%"}
      height={"100%"}
      alignItems="center"
      justifyContent="center"
    >
      <Box
        direction="column"
        minWidth={360}
        justifyContent="center"
        alignItems="center"
      >
        <img src={utilsCommon.renderWrapsodyECOLogo()} width={136} alt="logo" />
        <img
          src={require(currStep === "DELETED"
            ? "../../shared/images/pages/File/trash.png"
            : "../../shared/images/common/restrictClient.png")}
          style={{ marginTop: "20px" }}
        />
        <Typography type="h2" classes="mg mt-20">
          {currStep === "DELETED"
            ? t("login.link.deleteFile")
            : t("login.link.noAuth")}
        </Typography>
        <Typography
          type="body1_md"
          classes="mg mt-8"
          whiteSpace="break-spaces"
          exactColor={getColor("COLOR_TEXT_SECONDARY")}
          textAlign="center"
        >
          {currStep === "DELETED"
            ? t("login.link.deleteFileDesc")
            : t("login.link.noAuthDesc")}
        </Typography>
        <Button
          label={t("login.link.goHome")}
          classes="mg mt-40"
          width={"100%"}
          style={{ minWidth: "125px", height: "48px" }}
          btnStyle="fill"
          onClick={() =>
            navigate(
              utilsCommon.renderProperNavigatePath(
                loginDto?.ecoSystemLicenseStats?.featureAccessType === "LITE"
                  ? `/myInbox/received`
                  : "/home"
              )
            )
          }
        />
      </Box>
    </Box>
  );
};

export default MoveToWebUsingBySyncId;
